import { atomWithStorage } from 'jotai/utils'
import { createStringStorage } from './generics'

export type PlayerSortPreference = 'name' | 'number'

const stringStorage = createStringStorage<PlayerSortPreference>()

export const playerSortPreferenceAtom = atomWithStorage<PlayerSortPreference>(
  'playerSortPreference',
  'name',
  stringStorage
)
